module.exports = __webpack_public_path__ + "static/media/drawButton.31074815.png";